import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { timeout } from 'sh-www/utils/timeout';

const controllers = ['active', 'archived', 'search'].map(x => `projects.${x}`);

class ProjectsRoute extends Route {
  @service session;

  get controllerName() {
    return this.session.currentUser?.isSeller
      ? 'projects.seller'
      : null;
  }

  get templateName() {
    return this.session.currentUser?.isSeller
      ? 'projects.seller'
      : null;
  }

  get isSeller() {
    return this.session.currentUser.isSeller;
  }

  afterModel() {
    if (!this.session.currentUser.isSeller) {
      return timeout(1);
    }
  }

  /** @inheritDoc */
  setupController(_, __, transition) {
    super.setupController(...arguments);

    if (!this.isSeller) {
      return;
    }

    const { targetName } = transition;
    const { queryParams } = transition.to;

    // we have to make a best guess here at the route query params since we are loading multiple child views at once
    controllers.forEach((controllerName) => {
      this.controllerFor(controllerName).initializeModel.perform(controllerName === targetName ? queryParams : { });
    });
  }

  /** @inheritDoc */
  resetController(_, isExiting) {
    super.resetController(...arguments);

    if (!this.isSeller || !isExiting) {
      return;
    }

    controllers.forEach((controllerName) => {
      this.controllerFor(controllerName).invalidateModel.perform();
    });
  }
}

export default ProjectsRoute;
